var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#1976D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9191 27.7984C17.9191 27.9097 18.0094 28 18.1206 28H20.9934C21.1047 28 21.1947 27.9097 21.1947 27.7984V19.9369H23.2775C23.3819 19.9369 23.4691 19.8566 23.4781 19.7525L23.6784 17.3837C23.6881 17.2663 23.5956 17.1653 23.4775 17.1653H21.1947V15.485C21.1947 15.0909 21.5141 14.7716 21.9078 14.7716H23.5128C23.6244 14.7716 23.7144 14.6812 23.7144 14.57V12.2016C23.7144 12.0903 23.6244 12 23.5128 12H20.8009C19.2094 12 17.9191 13.29 17.9191 14.8816V17.1653H16.4828C16.3716 17.1653 16.2812 17.2556 16.2812 17.3669V19.7353C16.2812 19.8469 16.3716 19.9369 16.4828 19.9369H17.9191V27.7984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.3c5400484ffd692e237d279881c33e17.svg";
export { ForwardRef as ReactComponent };